import {AsyncResult, Loaded, Loading} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import QuoteSearchAPI from 'Quoting/api/QuoteSearchAPI';
import {QuoteSearchType} from 'Quoting/components/QuotingPage';
import {QuoteSearchActionType, changeQuoteSearch, fetchQuotes} from 'Quoting/ducks/quoteSearch';
import {QuoteSearchDto} from 'Quoting/models/DTOs/QuoteSearch';
import {call, put, takeLatest} from 'redux-saga/effects';

function* fetchQuoteSearchData(action: ReturnType<typeof fetchQuotes>) {
  const {searchtype, searchvalue} = action.payload;

  yield put(changeQuoteSearch(new Loading()));
  const quotefilter = {
    opportunityNumber: null,
    customerName: null,
    customerNumber: null,
  };
  switch (searchtype) {
    case QuoteSearchType.CustomerNumber:
      quotefilter.customerNumber = searchvalue;
      break;

    case QuoteSearchType.CustomerName:
      quotefilter.customerName = searchvalue;
      break;

    case QuoteSearchType.Opportunity:
      quotefilter.opportunityNumber = searchvalue;
      break;
  }

  if (searchvalue == null || searchvalue.length == 0) {
    const data = new Loaded({currentPageNumber: 0, links: [], result: [], totalCount: 0});
    yield put(changeQuoteSearch(data));
  } else {
    const response: AsyncResult<Page<QuoteSearchDto>> = yield call(
      QuoteSearchAPI.searchQuotes,
      quotefilter.opportunityNumber,
      quotefilter.customerNumber,
      quotefilter.customerName
    );

    yield pipe(
      response,
      E.map(value => new Loaded(value)),
      E.fold(
        error => put(changeQuoteSearch(error)),
        value => put(changeQuoteSearch(value))
      )
    );
  }
}

export default function*() {
  yield takeLatest(QuoteSearchActionType.FETCH_QUOTES, fetchQuoteSearchData);
}
